import T from 'prop-types';
import React, { useMemo } from 'react';
import { Peaks, Canvas } from '.';
import { useGetWaveForm } from '../../hooks/query/show';

function _base64ToArrayBuffer(base64) {
  const binary_string = window.atob(base64);
  const len = binary_string.length;
  let bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

const WaveForm = ({ audioUrl, width, episodeDuration, currentTime }) => {
  const { waveForm, isWaveFormDataLoading } = useGetWaveForm({ audioUrl });

  const waveFormData = useMemo(
    () => (waveForm ? new Peaks(_base64ToArrayBuffer(waveForm)) : null),
    [waveForm]
  );

  return (
    <div className="acast-audio-waveform">
      <div className="acast-waveform">
        <Canvas
          width={width}
          peaks={waveFormData}
          episodeDuration={episodeDuration}
          currentTime={currentTime}
          loading={isWaveFormDataLoading}
        />
      </div>
    </div>
  );
};

WaveForm.propTypes = {
  width: T.number.isRequired,
  episodeDuration: T.number,
  audioUrl: T.string,
  currentTime: T.number.isRequired,
};

export default WaveForm;
